import { observable } from '@legendapp/state';
export const tenantAliasObs = observable<string>();